import CryptoJS from "crypto-js";

const SECRET_KEY = "3xT9vAq1YpZ7gM5KdLfB2N8wR6sCJQX4"; // 🔑 Clave secreta para cifrado

// 🔐 Encriptar
export const encryptData = (data) => {
    return CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();
};

// 🔓 Desencriptar
export const decryptData = (cipherText) => {
    try {
        const bytes = CryptoJS.AES.decrypt(cipherText, SECRET_KEY);
        return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    } catch (error) {
        console.error("Error al desencriptar:", error);
        return null;
    }
};

export const saveToLocalStorage = (key, value) => {
    const encryptedValue = encryptData(value);
    localStorage.setItem(key, encryptedValue);
};

export const getFromLocalStorage = (key) => {
    const encryptedValue = localStorage.getItem(key);
    return encryptedValue ? decryptData(encryptedValue) : null;
};